/*globals $ */
class Ticker {
  constructor() {
    this.$window = $(window);
    this.$container = $(".ticker");
    this.$slider = this.$container.find(".tickerSlider");
    this.$first = this.$container.find(".tickerSlider__first");
    this.posX = 0;

    this.$window.on("resize", () => {
      this.onWindowResize();
    });
    this.init();
  }
  reset() {
    clearInterval(this.updateInterval);
    clearInterval(this.resizeCompleteInterval);
    clearInterval(this.waitInterval);
    this.$slider.css("opacity", 0);
    this.$slider.css("transform", `translateX(0px)`);
    this.posX = 0;
    $(".tickerSlider__second").remove();
    if (this.$first.find("span").length > 1) {
      this.$first.find("span").each((i, e) => {
        if (!$(e).hasClass("original")) {
          $(e).remove();
        }
      });
    }
  }
  init() {
    this.reset();
    if (!this.$container.css("display") != "none") {
      const $firstItem = this.$first.find("span");
      this.waitInterval = setInterval(() => {
        if ($firstItem.outerWidth(true) > 0) {
          clearInterval(this.waitInterval);

          const baseWidth = $firstItem.outerWidth(true);
          for (let i = 0; i < Math.ceil(window.innerWidth / baseWidth); i++) {
            this.$first.append($firstItem.clone());
          }
          this.$first.children("span:first-child").addClass("original");
          const $second = this.$first.clone();
          $second.attr(
            "class",
            $second
              .attr("class")
              .replace("tickerSlider__first", "tickerSlider__second")
          );
          this.repeatWidth = this.$first.width();

          this.$slider.append($second);
          this.start();
        }
      }, 1000 / 30);
    }
  }
  start() {
    this.$slider.css("opacity", 1);
    this.updateInterval = setInterval(() => {
      this.update();
    }, 20);
  }
  update() {
    this.posX -= 1;
    if (this.posX <= -this.repeatWidth) {
      this.posX = 0;
    }
    this.$slider.css("transform", `translateX(${this.posX}px)`);
  }
  onWindowResize() {
    clearInterval(this.updateInterval);
    clearInterval(this.resizeCompleteInterval);
    this.$slider.css("opacity", 0);
    this.resizeCompleteInterval = setInterval(() => {
      clearInterval(this.resizeCompleteInterval);
      this.init();
    }, 500);
  }
}

/*
class Ticker2 {
  constructor() {
    console.log("Ticker");
    this.$window = $(window);

    this.isRunning = false;

    this.$window.on("resize", () => {
      this.onWindowResize();
    });
    this.onWindowResize();
  }

  telopAnimation() {
    $(".ticker_text").css("left", this.count);
    if (this.count == this.animationCount) {
      this.count = 0;
      $(".ticker_text").css("left", "-" + this.count);
    } else {
      this.count = this.count - 1;
    }
  }

  init() {
    this.tickerWidth = $(".ticker_text span:first-child").innerWidth();
    this.contentWidth = $(".ticker").outerWidth();

    this.cloneNum = Math.ceil(this.contentWidth / this.tickerWidth) + 1;
    for (var i = 0; i < this.cloneNum; i++) {
      $(".ticker_text span:first-child").clone(true).appendTo(".ticker_text");
    }
    $(".ticker_text").css("width", this.tickerWidth * (this.cloneNum + 1));

    this.count = 1;
    this.textWidth = $(".ticker_text").outerWidth();
    this.animationCount = "-" + Math.ceil(this.textWidth);
    this.animationCount =
      parseInt(this.animationCount) + parseInt(this.contentWidth);
    console.log(this.animationCount);

    this.interval = setInterval(this.telopAnimation, 20);
  }
  onWindowResize() {
    if (window.innerWidth > 960) {
      if (!this.isRunning) {
        this.isRunning = true;
        this.init();
      }
    } else {
      if (this.isRunning) {
        this.isRunning = false;
        clearInterval(this.interval);
      }
    }
  }
}
*/
export default Ticker;
